import Link from "next/link";
import React, { useEffect, useState } from "react";
import { extractFormData } from "@/utils/function";
import { SignInApi } from "@/api/auth";
import { ToastContainer, toast } from "react-toastify";
import { useRouter } from "next/router";

import sal from "sal.js";

import { userStore } from "@/store/user";
import Cookies from "js-cookie";

const SignIn = () => {

  const router = useRouter();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    sal();

    const cards = document.querySelectorAll(".bg-flashlight");
    cards.forEach((bgflashlight) => {
      bgflashlight.onmousemove = function (e) {
        let x = e.pageX - bgflashlight.offsetLeft;
        let y = e.pageY - bgflashlight.offsetTop;

        bgflashlight.style.setProperty("--x", x + "px");
        bgflashlight.style.setProperty("--y", y + "px");
      };
    });
  }, []);

  const [formErrors, setFormErrors] = useState({
    email: false,
    password: false,
  });

  const handleInputChange = (e) => {
    const { name } = e.target;
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    const { email, password } = extractFormData(form);

    if (!email || !password) {
      setFormErrors({
        email: !email,
        password: !password,
      });
      setLoading(false);
      return;
    }

    try {
      const response = await SignInApi(email, password);
      if (response?.status !== 200) {
        toast.error(response?.data?.message || "Signin failed! Please try again.");
        setLoading(false);
        return;
      }
      userStore.setState({ user: response?.data });
      Cookies.set("speak_token", response?.data?.token, { expires: 7 });
      toast.success("Signin successful! Redirecting...");

      setTimeout(() => {
        router.push(handleSignInUrl())
      }, 500);
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Signin failed! Please try again.");
      setLoading(false);
    }
  };
  const handleSignInUrl = () => {
    const queryParams = router.query;
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `/share?${queryString}` : "/book-bot";
  };

  return (
    <>
      <ToastContainer />

      <div
        className="signup-area rainbow-section-gapTop-big"
        data-black-overlay="2"
      >
        <div className="sign-up-wrapper rainbow-section-gap">
          <div className="sign-up-box bg-flashlight">
            <div className="signup-box-top top-flashlight light-xl">
            </div>
            {/* <div className="separator-animated animated-true"></div> */}
            <div className="signup-box-bottom">
              <div className="signup-box-content">
                <h4 className="title">Welcome Back!</h4>

                <form onSubmit={handleSignIn}>
                  <div className="input-section mail-section">
                    <div className="icon">
                      <i className="feather-mail"></i>
                    </div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter email address"
                      onChange={handleInputChange}
                    />
                    {formErrors?.email && (
                      <span className="error">Email is required</span>
                    )}
                  </div>
                  <div className="input-section password-section">
                    <div className="icon">
                      <i className="feather-lock"></i>
                    </div>
                    <input
                      type="password"
                      name="password"
                      placeholder="Password"
                      onChange={handleInputChange}
                    />
                    {formErrors?.password && (
                      <span className="error">Password is required</span>
                    )}
                  </div>
                  <div className="forget-text">
                    <Link className="btn-read-more" href="/auth/forgot-password">
                      <span>Forgot password</span>
                    </Link>
                  </div>
                  <button
                    type="submit"
                    className="btn-default"
                    disabled={loading}
                  >
                    {loading ? <div className="spinner"></div> : "Sign In"}
                  </button>
                </form>
              </div>
              <div className="signup-box-footer">
                <div className="bottom-text">
                  Don&apos;t have an account?
                  <Link className="btn-read-more ps-2" href="/auth/signup">
                    <span>Sign Up</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;
